import {certificatemainUrls, certificatemain} from './certificatemain'

export const certificateUrls = [
  ...certificatemainUrls
]

export const certificate = {
  certificatemain
}



// WEBPACK FOOTER //
// ./src/api/gip/certificate/index.js